import { c as _c } from "react/compiler-runtime";
import { LeadCreationResponse, useGetLeadCalendar } from "@justhome/api-core";
import { Loader } from "@justhome/react-ui";
import useBookingTranslation from "@modules/booking/lib/hooks/useBookingTranslation";
import Meeting, { MeetingScheduledEvent } from "../Meeting";
interface CalendarStepProps {
  onMeetingScheduled: (event: MeetingScheduledEvent) => void;
  lead?: LeadCreationResponse;
  skipQualification?: boolean;
}
const getCookie = (name: string) => {
  const regex = new RegExp("(?:^|;\\s*)" + escapeRegex(name) + "=([^;]*)");
  const match = document.cookie.match(regex);
  if (!match) {
    return;
  }
  return match[1];
};
const escapeRegex = (value: string) => value.replace(/([.*+?^${}()|[\]/\\])/g, "\\$1");
const CalendarStep = t0 => {
  const $ = _c(26);
  const {
    onMeetingScheduled,
    lead,
    skipQualification
  } = t0;
  const {
    t
  } = useBookingTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getCookie("hubspotutk");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const hubspotUtk = t1;
  const t2 = lead?.id as string;
  let t3;
  if ($[1] !== t2) {
    t3 = {
      leadId: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = lead?.email || "";
  const t5 = lead?.phone || "";
  const t6 = lead?.firstName || "";
  const t7 = lead?.lastName || "";
  const t8 = skipQualification ? "GENERAL" : "ROUND_ROBIN";
  let t9;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6 || $[6] !== t7 || $[7] !== t8) {
    t9 = {
      email: t4,
      phone: t5,
      firstName: t6,
      lastName: t7,
      hubspotUtk: hubspotUtk || "",
      calendarType: t8
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t3 || $[10] !== t9) {
    t10 = {
      pathParams: t3,
      queryParams: t9
    };
    $[9] = t3;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const {
    data: url,
    isLoading
  } = useGetLeadCalendar(t10);
  let t11;
  if ($[12] !== t) {
    t11 = t("calendarStep.title");
    $[12] = t;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11) {
    t12 = <h2 className="text-h2 mb-m text-center">{t11}</h2>;
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== isLoading) {
    t13 = isLoading && <div className="flex justify-center items-center min-h-[230px]"><Loader size="lg" /></div>;
    $[16] = isLoading;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== isLoading || $[19] !== onMeetingScheduled || $[20] !== url) {
    t14 = !isLoading && url && <Meeting onMeetingScheduled={onMeetingScheduled} demodeskUrl={url} />;
    $[18] = isLoading;
    $[19] = onMeetingScheduled;
    $[20] = url;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t12 || $[23] !== t13 || $[24] !== t14) {
    t15 = <div className="flex flex-col max-w-full">{t12}{t13}{t14}</div>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
};
export default CalendarStep;